<template>
  <div
    id="filter"
    class="container"
    style="display: flex; padding-top: 0px; max-width: 900px !important"
  >
    <progress-bar :show="this.loading" color="primary" type="full" />
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Buscar Questões</h2>
        </v-flex>
      </v-layout>
      <question-filter @filter="applyFilter" />
    </v-container>
  </div>
</template>

<script>
import QuestionFilter from "@/components/quiz/QuestionFilter";

export default {
  components: {
    QuestionFilter,
  },
  mounted() {
    // console.log('mounted')
  },
  metaInfo() {
    return {
      title: "LS - Buscar Questões de Certificações",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Monte seu teste ou simulado com questões de certificações financeiras",
        },
      ],
    };
  },
  data() {
    return {
      filter: {
        courses: [],
        topics: [],
        subjects: [],
        neverSolved: false,
        limit: 50,
      },
      answers: null,
      dialog: false,
      currentQuestion: null,
      option: null,
      loading: false,
      questions: {},
      finished: false,
    };
  },
  computed: {
    score() {
      if (!this.finished) return 0;
      return this.questions.filter((item) => {
        return item.correct === true;
      }).length;
    },
    authenticated() {
      return this.$store.state.auth.user !== null;
    },
  },
  created() {
    this.loading = true;
    this.questions = [];
    this.currentQuestion = 1;
    this.loading = false;
    if (!this.authenticated) {
      window.getApp.sendSnackMessage(
        "Você precisa estar logado para corrigir as questões 😉",
      );
    }
  },
  methods: {
    applyFilter(filter, details) {
      console.log("filter applied", filter, details);
      const courseName = details.courses.find(
        (course) => course.id === filter.courseId,
      )?.course;
      const topicName = details.topics
        .filter((topic) => filter.topics.includes(topic.id))
        .map((topic) => topic.topic)
        .join(", ")
        .trim();
      const subjectName = details.subjects
        .filter((subject) => filter.subjects.includes(subject.id))
        .map((subject) => subject.subject)
        .join(", ")
        .trim();
      const search_term = `Curso: ${courseName || "nulo"} | Módulo: ${topicName || "nulo"} | Assunto: ${subjectName || "nulo"} | Conteúdo: ${filter.content || "nulo"}`;
      console.log("search_term", search_term);
      this.$gtag.query("event", "search", {
        search_term: search_term,
        course: courseName,
        topic: topicName,
        subject: subjectName,
        content: filter.content,
      });
      this.$router.push({
        name: "mocks.start",
        params: {
          id: "new",
        },
        query: filter,
      });
    },
  },
};
</script>
